// extracted by mini-css-extract-plugin
export default {"wrapper":"category-box_wrapper__7nJF3","description":"category-box_description__QeIUK","categoryBox":"category-box_categoryBox__OEtGj","btnBox":"category-box_btnBox__5qZ-O"};